function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useMemo } from 'react';
import { FilterPicker, Checkbox, Typography } from 'seagull';
export function VisibleColumnsPicker(props) {
  var _props$title, _props$type;
  const [selectedColumns, setSelectedColumns] = useState(props.visibleColumns);
  const numSelectedColumns = useMemo(() => Object.values(selectedColumns).filter(value => value).length, [selectedColumns]);
  return /*#__PURE__*/React.createElement(FilterPicker, {
    "data-testid": "".concat(props.testId, "-column-selector"),
    label: numSelectedColumns > 0 ? "".concat(numSelectedColumns, " columns selected") : 'None selected',
    title: props.type === 'button' ? (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : 'Additional columns' : 'Additional columns',
    highlightTrigger: false,
    onApply: () => props.onApply(selectedColumns),
    onClose: () => {},
    type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'chip',
    prefixIcon: props.type === 'button' ? props.prefixIcon : undefined
  }, Object.entries(selectedColumns).map(_ref => {
    var _props$fixedColumns;
    let [name, selected] = _ref;
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: name,
      name: name,
      disabled: (_props$fixedColumns = props.fixedColumns) === null || _props$fixedColumns === void 0 ? void 0 : _props$fixedColumns[name],
      "data-testid": "".concat(props.testId, "-column-picker-").concat(name.toLowerCase()),
      checked: !!selected,
      onChange: () => {
        setSelectedColumns(_objectSpread(_objectSpread({}, selectedColumns), {}, {
          [name]: !selected
        }));
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph1"
    }, name));
  }));
}